import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Table,
  Space,
  Modal,
  Form,
  Input,
  Typography,
  Row,
  Col,
  Checkbox,
  Upload,
  Progress,
  Tooltip,
} from "antd";
import { Link } from "react-router-dom";
import {
  EditOutlined,
  MinusCircleOutlined,
  StepForwardOutlined,
  PlaySquareOutlined,
  PlusOutlined,
  UploadOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/store.ts";

import assesmentService from "../../services/assessmentService.ts";
import topicService from "../../services/topic-service.ts";
import Constant from "../../global/Constant.ts";
import { setLoading, addNotification } from "../../redux/globalSlice.ts";
import { generateCertificate } from "../../components/certificate/generateCertificate.tsx";
import { userType } from "../../global/enums.ts";

const AssessmentQuestion = () => {
  const [visible1, setVisible1] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [participantToRemove, setParticipantToRemove] = useState(null);
  const [modal, setModal] = useState("");
  const [teamform] = Form.useForm();
  const [topicPool, setTopicPool] = useState([]);
  const [assesment, setAssessments] = useState([]);
  const [assessmentId, setAssessmentId] = useState(0);
  const [loading, setLoadingbutton] = useState(false);
  const [csvFileUploaded, setCsvFileUploaded] = useState(false);
  const [manualRowsAdded, setManualRowsAdded] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [formTitle, setFormTitle] = useState("");
  const [topicSearchTerm, setTopicSearchTerm] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
  const userData = useSelector((state: RootState) => state.auth.userData);
  const loggedUserDetails = useSelector(
    (state: RootState) => state.user.userDetails
  );
  const [currentUser, setCurrentUser] = useState(false);
  const dispatch = useDispatch();

  // Helper function to check if user is in group
  const isGroupUser = () =>
    String(loggedUserDetails?.UserType) === userType.Group;
  const is_PureIndividual = () =>
    loggedUserDetails?.ParentId === loggedUserDetails?.UserID ||
    loggedUserDetails?.ParentId == null;

  useEffect(() => {
    if (loggedUserDetails) {
      setCurrentUser({
        name: loggedUserDetails?.FirstName,
        email: loggedUserDetails?.Email,
      });
    }
  }, [loggedUserDetails]);

  useEffect(() => {
    setFormTitle(assessmentId ? "Your Topic" : "Select Your Topic");
  }, [assessmentId]);

  const fetchAssessments = async () => {
    try {
      dispatch(setLoading(true));
      const payload = {
        page: pagination.current,
        limit: pagination.pageSize,
      };
      const response = await assesmentService.getAssessmentByEmail(
        Constant?.assessment,
        payload
      );

      const assessmentsWithProgress = response.data.map((record) => {
        const progressPercentage = calculateProgressPercentage(record);
        const myProgressPercentage = calculateMyProgressPercentage(record);
        if (isGroupUser()) {
          return {
            ...record,
            progress: <Progress percent={progressPercentage} />,
            myProgress: <Progress percent={myProgressPercentage} />,
          };
        }
        return {
          ...record,
          progress: <Progress percent={progressPercentage} />,
        };
      });

      setAssessments(assessmentsWithProgress);
      setPagination((prev) => ({ ...prev, total: response.totalRecords }));
    } catch (error) {
      console.error("No Assesments Found:");
    } finally {
      dispatch(setLoading(false));
    }
  };

  const calculateProgressPercentage = (record) => {
    if (isGroupUser()) {
      return record.QuestionCount > 0
        ? record.AverageNumberOfQuestionAttended
        : 0;
    }
    return record.QuestionCount > 0
      ? Math.round(
          (record.NumberOfQuestionAttended / record.QuestionCount) * 100
        )
      : 0;
  };

  const calculateMyProgressPercentage = (record) => {
    return record.QuestionCount > 0
      ? Math.round(
          (record.NumberOfQuestionAttended / record.QuestionCount) * 100
        )
      : 0;
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (currentUser?.email) {
      fetchAssessments();
    }
  }, [currentUser, dispatch, pagination.current, pagination.pageSize]);

  const handleTableChange = (currpagination) => {
    setPagination(currpagination);
  };

  const handleEdit = async (record) => {
    setLoadingbutton(false);
    setModal("edit");
    setCsvFileUploaded(false);
    setManualRowsAdded(false);
    setAssessmentId(record?.AssessmentID);

    const updatedTopicPool = [
      {
        TopicsID: record.TopicsID,
        TopicName: record.TopicName,
        selected: true,
        locked: true,
      },
    ];

    setTopicPool(updatedTopicPool);

    teamform.setFieldsValue({
      users: record.userData
        .filter((user) => user.email !== userData?.signInDetails?.loginId)
        .map((user) => ({
          Name: user.name,
          last: user.email,
          isAttended: user.isAttended,
        })),
    });

    setVisible1(true);
  };

  const capitalize = (firstName, lastName) => {
    let capitalizedFirstName =
      firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();

    if (lastName) {
      let capitalizedLastName =
        lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase();
      return `${capitalizedFirstName} ${capitalizedLastName}`;
    }

    return capitalizedFirstName;
  };

  const handleDownloadClick = async (loggedUser, record) => {
    dispatch(setLoading(true));
    let currentUserType = "participant"; // Default value
    if (loggedUser?.UserType === 0) {
      if (
        loggedUser?.ParentId === loggedUser?.UserID ||
        loggedUser?.ParentId == null
      ) {
        if (record?.CreatedBy === loggedUser?.UserID) {
          currentUserType = "individual";
        }
      }
    }

    try {
      //generate the certificate
      const metaData = {
        record,
        userName:
          capitalize(loggedUser?.FirstName, loggedUser?.LastName) ||
          "Participant",
        userType: currentUserType,
        loggedUser,
      };

      //wait for PDF generation to complete successfully
      await new Promise((resolve, reject) => {
        generateCertificate(metaData, (error) => {
          dispatch(setLoading(false));
          if (error) {
            reject(error);
          } else {
            resolve();
          }
        });
      });

      //if PDF succeeds, update backend status
      await assesmentService.updateCertificateDownloadStatus(
        Constant?.assessmentparticipants,
        record.AssessmentID
      );
    } catch (error) {
      console.error("Certificate download failed:", error);
      dispatch(
        addNotification({
          title: "Error",
          description: "Failed to download certificate",
          type: "error",
        })
      );
    }
  };

  const shouldShowDownloadIcon = (loggedUser, record) => {
    if (!loggedUser || !record) return false;

    if (loggedUser?.UserType === 2) {
      return (
        record?.groupsucess &&
        record?.QuestionCount === record?.NumberOfQuestionAttended
      );
    }

    if (loggedUser?.UserType === 0) {
      if (
        loggedUser?.ParentId === loggedUser?.UserID ||
        loggedUser?.ParentId == null
      ) {
        if (record?.CreatedBy === loggedUser?.UserID) {
          return (
            record?.Succeed &&
            record?.QuestionCount === record?.NumberOfQuestionAttended
          );
        } else {
          return (
            record?.groupsucess &&
            record?.QuestionCount === record?.NumberOfQuestionAttended
          );
        }
      }
      return (
        record?.groupsucess &&
        record?.QuestionCount === record?.NumberOfQuestionAttended
      );
    }

    return false;
  };

  const renderDownloadIcon = (loggedUser, record) => {
    if (!shouldShowDownloadIcon(loggedUser, record)) return null;

    return (
      <Link
        onClick={() => handleDownloadClick(loggedUser, record)}
        // className="vm__table-icons vm__certificate-disabled"
        className="vm__table-icons"
      >
        <span className="vm__certificate-download ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 645 868"
            fill="none"
          >
            <g clip-path="url(#clip0_917_51)">
              <path
                d="M644.79 322.39C644.79 302.08 606.66 285.77 602.86 266.58C598.95 246.8 627.86 217.18 620.32 198.98C612.64 180.47 571.18 180 560.16 163.55C549.06 146.96 564.42 108.48 550.36 94.42C536.3 80.36 497.82 95.72 481.23 84.63C464.77 73.61 464.31 32.15 445.8 24.47C427.6 16.92 397.98 45.83 378.2 41.93C359 38.13 342.7 0 322.39 0C302.08 0 285.77 38.13 266.58 41.93C246.8 45.84 217.18 16.93 198.98 24.47C180.47 32.15 180 73.61 163.55 84.63C146.96 95.73 108.48 80.37 94.42 94.43C80.36 108.49 95.72 146.97 84.63 163.56C73.61 180.02 32.15 180.48 24.47 198.99C16.92 217.19 45.83 246.81 41.93 266.59C38.13 285.79 0 302.09 0 322.4C0 342.71 38.13 359.02 41.93 378.21C45.84 397.99 16.93 427.61 24.47 445.81C32.15 464.32 73.61 464.79 84.63 481.24C95.73 497.83 80.37 536.31 94.43 550.37C108.49 564.43 146.97 549.07 163.56 560.16C180.02 571.18 180.48 612.64 198.99 620.32C217.19 627.87 246.81 598.96 266.59 602.86C285.79 606.66 302.09 644.79 322.4 644.79C342.71 644.79 359.02 606.66 378.21 602.86C397.99 598.95 427.61 627.86 445.81 620.32C464.32 612.64 464.79 571.18 481.24 560.16C497.83 549.06 536.31 564.42 550.37 550.36C564.43 536.3 549.07 497.82 560.16 481.23C571.18 464.77 612.64 464.31 620.32 445.8C627.87 427.6 598.96 397.98 602.86 378.2C606.66 359 644.79 342.7 644.79 322.39ZM322.39 535.04C204.95 535.04 109.74 439.83 109.74 322.39C109.74 204.95 204.95 109.74 322.39 109.74C439.83 109.74 535.04 204.95 535.04 322.39C535.04 439.83 439.83 535.04 322.39 535.04Z"
                fill="#52c41a"
              />
              <path
                d="M322.39 512.3C427.274 512.3 512.3 427.274 512.3 322.39C512.3 217.506 427.274 132.48 322.39 132.48C217.506 132.48 132.48 217.506 132.48 322.39C132.48 427.274 217.506 512.3 322.39 512.3Z"
                fill="#52c41a"
              />
              <path
                d="M304.97 656.73L236.95 855.45C231.51 871.33 209.68 872.92 202 858L160.85 778.05C156.78 770.15 147.79 766.1 139.18 768.32L60.83 788.47C44.46 792.68 31.14 775.07 39.63 760.46L148.81 572.64C152.73 573.03 154.04 573.76 154.32 573.94C154.47 574.04 155.88 575.07 158.11 579.55C160.2 583.78 162.09 589.14 164.08 594.81C169.67 610.72 176.01 628.74 192.63 635.64C196.68 637.32 201.09 638.17 205.76 638.17C217.92 638.17 229.71 632.53 241.12 627.07C248.55 623.52 257.81 619.09 262.68 619.09C263.06 619.09 263.27 619.12 263.37 619.14C263.44 619.15 265.06 619.5 268.79 622.76C272.3 625.82 276.06 630.01 280.04 634.45C287.38 642.62 295.34 651.5 304.99 656.74L304.97 656.73Z"
                fill="#52c41a"
              />
              <path
                d="M583.94 788.46L505.59 768.31C496.98 766.09 487.98 770.13 483.92 778.04L442.77 857.99C435.09 872.91 413.26 871.32 407.82 855.44L339.81 656.73C349.45 651.48 357.42 642.6 364.76 634.43C368.74 630 372.5 625.81 376.01 622.74C379.73 619.49 381.36 619.14 381.42 619.12C381.52 619.1 381.74 619.07 382.11 619.07C386.97 619.07 396.23 623.5 403.67 627.05C415.08 632.51 426.87 638.15 439.03 638.15C443.7 638.15 448.12 637.3 452.16 635.62C468.78 628.73 475.12 610.7 480.7 594.8C482.7 589.13 484.58 583.77 486.68 579.54C488.9 575.06 490.31 574.03 490.47 573.93C490.75 573.74 492.05 573.02 495.98 572.63L605.16 760.44C613.65 775.05 600.32 792.66 583.96 788.45L583.94 788.46Z"
                fill="#52c41a"
              />
              <path
                d="M297.37 390.63C292.24 390.63 287.32 388.59 283.69 384.96L230.06 331.33C222.5 323.77 222.5 311.52 230.06 303.97C237.62 296.41 249.87 296.41 257.42 303.97L297.37 343.92L376.26 265.03C383.82 257.47 396.06 257.47 403.62 265.03C411.18 272.59 411.18 284.83 403.62 292.39L311.05 384.96C307.42 388.59 302.5 390.63 297.37 390.63Z"
                fill="white"
              />
            </g>
          </svg>
        </span>

        <span></span>
      </Link>
    );
  };

  const getIndividualProgressTooltip = (record, requiredProgress) => {
    const currentProgress = Math.round(
      (record.NumberOfQuestionAttended / record.QuestionCount) * 100
    );
    const correctPercentage = Math.round(
      (record.correctAnswersCount / record.QuestionCount) * 100
    );
    const isFullyAttempted =
      record.NumberOfQuestionAttended === record.QuestionCount;
    const meetsCorrectnessRequirement = correctPercentage >= requiredProgress;
    const remainingPercentage = requiredProgress - correctPercentage;
    const status = record.Succeed ? "Qualified" : "Not Qualified";

    const correctnessStatus = meetsCorrectnessRequirement
      ? "Done"
      : "Need " + remainingPercentage + "% more";

    return (
      `Your Progress: ${currentProgress}% (${record.NumberOfQuestionAttended}/${record.QuestionCount} questions)\n` +
      `Correct Answers: ${correctPercentage}% (${record.correctAnswersCount}/${record.QuestionCount})\n` +
      `\n` +
      `Requirements to Pass:\n` +
      `Attempt all questions (${isFullyAttempted ? "Done" : "Pending"})\n` +
      `Score at least ${requiredProgress}% correct (${correctnessStatus})\n` +
      `\n` +
      `Status: ${status}`
    );
  };

  const getGroupProgressTooltip = (record, isTeamView = false) => {
    const currentParticipation = Math.round(
      (record.numberOfAttendedParticipants / record.ParticipantsCount) * 100
    );
    const currentSuccess = parseFloat(record.groupsuccessPercentage);
    const requiredParticipation = record.MinimumParticipationCount;
    const requiredSuccess = record.MinimumSucceedCount;
    const status = record.groupsucess ? "qualified" : "not qualified";
    const prefix = isTeamView ? "Team" : "Your team's";

    return (
      `${prefix} progress:\n` +
      `- Participation: ${currentParticipation}% (${record.numberOfAttendedParticipants}/${record.ParticipantsCount})\n` +
      `- Success rate: ${currentSuccess.toFixed(2)}%\n\n` +
      `Your success rate: ${record?.SuccessCount}%\n\n` +
      `Requirements:\n` +
      `- ${requiredParticipation}% participation needed\n` +
      `- ${requiredSuccess}% success rate needed\n` +
      `Current status: ${status}`
    );
  };

  const getProgressTooltipContent = (record, isSelfProgress = false) => {
    const loggedUser = loggedUserDetails;
    const is_GroupUser = loggedUser?.UserType === 2;
    const isIndividualWithParent =
      loggedUser?.UserType === 0 &&
      loggedUser?.ParentId &&
      loggedUser?.ParentId !== loggedUser?.UserID;
    const isPureIndividual =
      loggedUser?.UserType === 0 &&
      (loggedUser?.ParentId === loggedUser?.UserID ||
        loggedUser?.ParentId == null);

    if (isSelfProgress) {
      return getIndividualProgressTooltip(record, record.MinimumSucceedCount);
    }

    if (is_GroupUser) {
      return getGroupProgressTooltip(record, true);
    }

    if (isIndividualWithParent) {
      return getGroupProgressTooltip(record);
    }

    if (isPureIndividual) {
      return getIndividualProgressTooltip(record, record.MinimumSucceedCount);
    }

    return "";
  };

  const columns = [
    {
      title: "Sl.No",
      key: "slNo",
      width: 80,
      align: "left",
      className: "vm__no-wrap",
      render: (_, record, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: "Topic",
      dataIndex: "TopicName",
      key: "TopicName",
      with: 400,
      className: "vm__min-col vm__no-wrap",
    },
    {
      title: "No. of Questions",
      dataIndex: "QuestionCount",
      key: "QuestionCount",
      width: 130,
      align: "center",
      className: "vm__no-wrap",
    },
    {
      title: "Date",
      dataIndex: "StartTime",
      key: "StartTime",
      width: 130,
      className: "vm__no-wrap",
      render: (text) => formatDate(text),
    },
    ...(isGroupUser()
      ? [
          {
            title: "No. of Participants",
            dataIndex: "ParticipantsCount",
            key: "ParticipantsCount",
            width: 130,
            align: "center",
            className: "vm__no-wrap",
          },
        ]
      : []),
    {
      title: isGroupUser() ? "Team Progress" : "Progress",
      dataIndex: "progress",
      key: "progress",
      width: 200,
      className: "vm__column-progress vm__no-wrap",
      render: (_, record) => (
        <>
          {!(
            loggedUserDetails?.UserType === 2 &&
            record?.CreatedBy !== loggedUserDetails?.UserID
          ) && (
            <div className="vm__d-flex vm__gap-3">
              <div className="vm__flex-fill">
                <Progress percent={calculateProgressPercentage(record)} />
              </div>
              <div className="vm__flex-auto">
                <Tooltip
                  title={getProgressTooltipContent(record, false)}
                  overlayStyle={{
                    whiteSpace: "pre-line",
                    maxWidth: 400,
                  }}
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </div>
            </div>
          )}
        </>
      ),
    },
    ...(isGroupUser()
      ? [
          {
            title: "My Progress",
            dataIndex: "myProgress",
            key: "myProgress",
            width: 200,
            className: "vm__column-progress vm__no-wrap",
            render: (_, record) => (
              <>
                <div className="vm__d-flex vm__gap-3">
                  <div className="vm__flex-fill">
                    <Progress percent={calculateMyProgressPercentage(record)} />
                  </div>
                  <div className="vm__flex-auto">
                    <Tooltip
                      title={getProgressTooltipContent(record, true)}
                      overlayStyle={{
                        whiteSpace: "pre-line",
                        maxWidth: 400,
                      }}
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </div>
                </div>
              </>
            ),
          },
        ]
      : []),
    {
      title: "Actions",
      key: "actions",
      width: 80,
      className: "vm__no-wrap",
      render: (_, record, index) => (
        <Space>
          {loggedUserDetails?.UserType !== 0 &&
            record?.CreatedBy === loggedUserDetails?.UserID && (
              <span
                className="vm__table-icons"
                onClick={() => handleEdit(record)}
              >
                <EditOutlined />
              </span>
            )}

          {record?.NumberOfQuestionAttended > 0 &&
            record?.NumberOfQuestionAttended !== record?.QuestionCount && (
              <Link
                to={`/assessment/${record.AssessmentID}?resume=true`}
                className="vm__table-icons"
              >
                <StepForwardOutlined />
              </Link>
            )}
          {(record?.NumberOfQuestionAttended === 0 ||
            record?.NumberOfQuestionAttended === record?.QuestionCount) && (
            <Link
              to={`/assessment/${record?.AssessmentID}`}
              className="vm__table-icons"
            >
              <PlaySquareOutlined />
            </Link>
          )}
        </Space>
      ),
    },
    {
      title: "Certificate",
      key: "certificate",
      width: 80,
      align: "left",
      className: "vm__no-wrap",
      render: (_, record) => renderDownloadIcon(loggedUserDetails, record),
    },
  ];

  const formatDate = (text) => {
    const date = new Date(text);
    const formattedDate = date.toLocaleDateString("en-GB", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    });
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate} ${formattedTime}`;
  };

  const handleNewAssessment = async () => {
    setLoadingbutton(false);

    if (!isLoggedIn) {
      setShowAuthModal(true);
      return;
    }

    dispatch(setLoading(true));
    setModal("create");
    setTopicSearchTerm("");
    teamform.resetFields();
    teamform.setFieldsValue({ users: [] });
    setCsvFileUploaded(false);

    try {
      const response = await topicService.getAllTopicsByIsForAssessment(
        Constant.topic
      );
      if (response.length === 0) {
        dispatch(
          addNotification({
            title: "Warning",
            description: "Something went wrong. Please try again.",
            type: "warning",
          })
        );
        return;
      }

      setTopicPool(response.map((q) => ({ ...q, selected: false })));
      setVisible1(true);
    } catch (error) {
      console.error("Error fetching all questions:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSubmitAssesment = async () => {
    try {
      const selectedTopicIDs = getSelectedTopicIDs();
      if (selectedTopicIDs.length === 0) {
        showWarningNotification("At least one topic must be selected");
        return;
      }

      const values = await teamform.validateFields();
      setLoadingbutton(true);

      if (fileList.length > 0) {
        await handleCsvFileUpload(selectedTopicIDs);
      } else {
        await handleManualSubmission(selectedTopicIDs, values);
      }
    } catch (error) {
      if (error.errorFields) {
        console.error("Validation failed:", error.errorFields);
      } else {
        handleError(error);
      }
    } finally {
      resetState();
    }
  };

  const getSelectedTopicIDs = () => {
    return topicPool
      .filter((topic) => topic.selected)
      .map((topic) => topic.TopicsID);
  };

  const showWarningNotification = (description) => {
    dispatch(
      addNotification({
        title: "Warning",
        description,
        type: "warning",
      })
    );
  };

  const handleCsvFileUpload = async (selectedTopicIDs) => {
    if (fileList.length === 0) {
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0]);
    formData.append("topicID", JSON.stringify(selectedTopicIDs));
    formData.append("userType", loggedUserDetails?.UserType);
    formData.append("startTime", Math.floor(Date.now() / 1000).toString());
    formData.append("groupemail", loggedUserDetails?.Email);
    formData.append("userId", loggedUserDetails?.UserID);
    formData.append("CreatedBy", loggedUserDetails?.UserID);
    formData.append("groupname", loggedUserDetails?.FirstName);

    try {
      const response = await assesmentService.createAssessmentByFile(
        Constant.assessment,
        formData
      );

      if (response.status === 200) {
        const newTotalAssessments = pagination.total + 1;
        const maxPage = Math.ceil(newTotalAssessments / pagination.pageSize);

        if (pagination.current < maxPage) {
          setPagination((prev) => ({ ...prev, current: maxPage }));
        }
        dispatch(
          addNotification({
            title: "Success",
            description: response?.data?.message,
            type: "success",
          })
        );
        setFileList([]);
        fetchAssessments();
        setVisible1(false);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        dispatch(
          addNotification({
            title: "Failed",
            description: error?.response?.data?.error,
            type: "error",
          })
        );
      }
      console.error("Error uploading file:", error);
    }
  };

  const handleManualSubmission = async (selectedTopicIDs, values) => {
    const currentuserData = handleManualUserAddition(values);
    if (!currentuserData) return;

    const participantsCount = currentuserData.length;

    if (modal === "create") {
      await createNewAssessment(
        selectedTopicIDs,
        currentuserData,
        participantsCount
      );
    } else if (modal === "edit") {
      await updateExistingAssessment(currentuserData);
    }
  };

  const handleManualUserAddition = (values) => {
    if (
      isGroupUser() &&
      (!Array.isArray(values.users) || values.users.length < 3)
    ) {
      showWarningNotification("At least three teammate required");
      return null;
    }

    const currentuserData =
      values.users?.map((user) => ({
        name: user.Name,
        email: user.last,
        isAttended: user.isAttended,
      })) || [];

    if (
      currentUser &&
      !currentuserData.some((user) => user.email === currentUser.email)
    ) {
      currentuserData.push(currentUser);
    }

    return currentuserData;
  };

  const createNewAssessment = async (
    selectedTopicIDs,
    currentuserData,
    participantsCount
  ) => {
    try {
      const payload = {
        topicID: selectedTopicIDs,
        userType: loggedUserDetails?.UserType,
        participantsCount: participantsCount,
        userData: currentuserData,
        userId: loggedUserDetails?.UserID,
        CreatedBy: loggedUserDetails?.UserID,
        startTime: Math.floor(Date.now() / 1000),
      };

      const response = await assesmentService.createAssessment(
        Constant.assessment,
        payload
      );

      dispatch(
        addNotification({
          title: "Success",
          description: response?.data?.message,
          type: "success",
        })
      );
      fetchAssessments();
      setVisible1(false);

      const newTotalAssessments = pagination.total + 1;
      const maxPage = Math.ceil(newTotalAssessments / pagination.pageSize);

      if (pagination.current < maxPage) {
        setPagination((prev) => ({ ...prev, current: maxPage }));
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const updateExistingAssessment = async (currentuserData) => {
    try {
      const originalUserData = currentuserData;
      const deleteUser = originalUserData;

      const assessmentData = assesment.find(
        (a) => a.AssessmentID === assessmentId
      );
      const userData1 = assessmentData ? assessmentData.userData : [];

      const deleteUser2 = userData1.filter(
        (user1) => !deleteUser.some((user2) => user2.email === user1.email)
      );

      const payload = {
        AssessmentID: assessmentId,
        userData: currentuserData,
        deleteUser: deleteUser2,
        userId: loggedUserDetails?.UserID,
      };

      const response = await assesmentService.updateAssessment(
        Constant.assessment,
        payload
      );

      dispatch(
        addNotification({
          title: "Success",
          description:
            response?.data?.message || "Training updated successfully!",
          type: "success",
        })
      );
      fetchAssessments();
      setVisible1(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleApiError = (error) => {
    if (error?.response?.data?.error) {
      dispatch(
        addNotification({
          title: "Failed",
          description: error?.response?.data?.error,
          type: "error",
        })
      );
    } else {
      dispatch(
        addNotification({
          title: "Failed",
          description: "An unexpected error occurred. Please try again.",
          type: "error",
        })
      );
    }
  };

  const handleError = (error) => {
    dispatch(
      addNotification({
        title: "Failed",
        description: "Something went wrong. Please try again.",
        type: "error",
      })
    );
    console.error("Failed to submit topic:", error);
  };

  const resetState = () => {
    setManualRowsAdded(false);
    setLoadingbutton(false);
  };

  const UserFieldItem = ({ name, restField, form, remove, fields }) => {
    const isAttended = form.getFieldValue(["users", name, "isAttended"]);

    const handleRemove = (fieldItem) => {
      const users = teamform.getFieldValue("users");
      const userToRemove = users[fieldItem];

      if (!userToRemove.Name && !userToRemove.last) {
        remove(fieldItem);
        if (users.length === 1) {
          setManualRowsAdded(false);
        }
      } else {
        setParticipantToRemove(fieldItem);
        setShowConfirmation(true);
      }
    };

    return (
      <Space
        style={{ display: "flex", marginBottom: 8 }}
        align="baseline"
        className={`vm__form-group-container vm__mt-3 ${
          isAttended ? "vm__member-disabled" : ""
        }`}
      >
        <Form.Item
          {...restField}
          name={[name, "Name"]}
          rules={[{ required: true, message: "Enter Name" }]}
          className="vm__mb-2 vm__flex-fill"
        >
          <Input placeholder="Name" disabled={isAttended} />
        </Form.Item>
        <Form.Item
          {...restField}
          name={[name, "last"]}
          rules={[
            { required: true, message: "Enter email" },
            { type: "email", message: "Enter a valid email address" },
          ]}
          className="vm__mb-2 vm__flex-fill"
        >
          <Input placeholder="Email Address" disabled={isAttended} />
        </Form.Item>

        <MinusCircleOutlined
          onClick={() => handleRemove(name)}
          style={{
            color: isAttended ? "#d9d9d9" : "inherit",
            cursor: isAttended ? "not-allowed" : "pointer",
            opacity: isAttended ? 0.5 : 1,
          }}
        />
      </Space>
    );
  };

  const BulkUploadButton = ({ assessmentIdd, fileListt, manualRowsAddedd }) => {
    if (assessmentIdd) return null;

    return (
      <Form.Item
        name="file"
        className="vm__mb-0"
        valuePropName="fileList"
        getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
      >
        <Upload
          accept=".csv"
          fileList={fileListt}
          maxCount={1}
          beforeUpload={(file) => {
            setFileList([file]);
            setCsvFileUploaded(true);
            return false;
          }}
          onRemove={() => {
            setFileList([]);
            setCsvFileUploaded(false);
          }}
        >
          <Button icon={<UploadOutlined />} disabled={manualRowsAddedd}>
            Bulk Upload Teammates
          </Button>
        </Upload>
      </Form.Item>
    );
  };

  const AddTeammatesButton = ({ csvFileUploadedd, setManualRowsAddedd }) => {
    return (
      <Button
        type="primary"
        onClick={() => {
          const users = teamform.getFieldValue("users") || [];
          teamform.setFieldsValue({
            users: [...users, { Name: "", last: "" }],
          });
          setManualRowsAddedd(true);
        }}
        icon={<PlusOutlined />}
        disabled={csvFileUploadedd}
      >
        Add Teammates
      </Button>
    );
  };

  const UserFields = ({ fields, add, remove, form }) => {
    return (
      <>
        {fields.map(({ key, name, ...restField }) => (
          <UserFieldItem
            key={key}
            name={name}
            restField={restField}
            form={form}
            remove={remove}
            fields={fields}
          />
        ))}
        <div className="vm__btn-fixed vm__d-flex vm__gap-2">
          <BulkUploadButton
            assessmentIdd={assessmentId}
            fileListt={fileList}
            manualRowsAddedd={manualRowsAdded}
          />
          <AddTeammatesButton
            csvFileUploadedd={csvFileUploaded}
            setManualRowsAddedd={setManualRowsAdded}
          />
        </div>
      </>
    );
  };

  const toggleTopicSelect = (topicId) => {
    setTopicPool((prevTopics) =>
      prevTopics.map((topic) => {
        if (topic.locked) {
          return topic;
        }

        if (topic.TopicsID === topicId) {
          return { ...topic, selected: !topic.selected };
        }

        return topic;
      })
    );
  };

  return (
    <div className="vm__assessment vm__h-100">
      <div className="vm__d-flex vm__flex-column vm__h-100">
        <div className="vm__flex-auto">
          <div className="vm__container">
            <div className="vm__d-flex vm__mb-3 vm__align-items-center vm__flex-wrap vm__gap-2">
              {isLoggedIn && (
                <div className="vm__flex-fill">
                  <h3 className="vm__page-header vm__mb-0">Training</h3>
                </div>
              )}

              {isLoggedIn && is_PureIndividual() && (
                <div className="vm__flex-auto">
                  <div className="vm__text-end ">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => handleNewAssessment()}
                    >
                      New Training
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="vm__flex-fill vm__overflow-auto">
          <div className="vm__container">
            {isLoggedIn && (
              <Table
                dataSource={assesment}
                columns={assesment && assesment.length > 0 ? columns : []}
                rowKey="id"
                scroll={{ x: true }}
                className={
                  assesment && assesment.length > 0 ? "vm__table-container" : ""
                }
                pagination={pagination}
                onChange={handleTableChange}
              />
            )}

            <Modal
              visible={visible1}
              onCancel={() => {
                setVisible1(false);
                setAssessmentId(0);
                setFileList([]);
                setManualRowsAdded(false);
                setTopicSearchTerm("");
              }}
              maskClosable={false}
              confirmLoading={loading}
              onOk={() => {
                if (isGroupUser()) {
                  teamform.submit();
                } else {
                  handleSubmitAssesment();
                }
              }}
              width={767}
              className="vm__modal vm__modal-lg"
              title={
                assessmentId !== 0 ? "Edit Training" : "Create New Training"
              }
            >
              <div className="vm__d-flex vm__flex-column vm__scroll-h vm__scroll-h-md vm__gap-3 vm__hidden-item">
                {isGroupUser() && (
                  <>
                    <div
                      className="vm__text-end"
                      style={{ textAlign: "center" }}
                    >
                      <Typography.Text type="secondary" italic>
                        <a
                          href="./teammates.csv"
                          download="sample_teammates.csv"
                        >
                          Download Sample Teammates CSV
                        </a>
                      </Typography.Text>
                    </div>
                  </>
                )}
                <div className="vm__flex-fill vm__overflow-auto vm__px-3">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 16,
                    }}
                  >
                    <Typography.Text strong>{formTitle}</Typography.Text>
                    {assessmentId === 0 && (
                      <Input.Search
                        placeholder="Search topics..."
                        onChange={(e) => setTopicSearchTerm(e.target.value)}
                        value={topicSearchTerm}
                        allowClear
                        style={{ width: 300 }}
                      />
                    )}
                  </div>

                  <Row gutter={[16, 16]}>
                    {topicPool
                      .filter((item) =>
                        item.TopicName.toLowerCase().includes(
                          topicSearchTerm.toLowerCase()
                        )
                      )
                      .map((item) => (
                        <Col span={12} key={item.TopicsID}>
                          <Card bodyStyle={{ padding: 12 }}>
                            <Checkbox
                              checked={item.selected}
                              disabled={item.locked}
                              onChange={() => toggleTopicSelect(item.TopicsID)}
                            >
                              {item.TopicName}
                            </Checkbox>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                </div>

                {isGroupUser() && (
                  <div className="vm__flex-auto vm__px-3">
                    <div className="vm__add-group-container">
                      <div className="vm__section-title">
                        <h3 className="vm__h4 vm__mb-0 vm__text-bold vm__title-h vm__d-flex vm__align-items-center">
                          Add Your Teammates
                        </h3>
                      </div>
                      <Form
                        name="dynamic_form_nest_item"
                        autoComplete="off"
                        className="vm__pe-2 vm__max-h-sm vm__p-3"
                        form={teamform}
                        onFinish={handleSubmitAssesment}
                      >
                        <Form.List name="users">
                          {(fields, { add, remove }) => (
                            <UserFields
                              fields={fields}
                              add={add}
                              remove={remove}
                              form={teamform}
                            />
                          )}
                        </Form.List>
                      </Form>
                    </div>
                  </div>
                )}
              </div>
            </Modal>

            <Modal
              visible={showConfirmation}
              onCancel={() => setShowConfirmation(false)}
              maskClosable={false}
              onOk={() => {
                teamform.getFieldValue("users").splice(participantToRemove, 1);
                setShowConfirmation(false);
                setParticipantToRemove(null);
              }}
              okText="Yes, remove"
              cancelText="Cancel"
            >
              <p>Are you sure you want to remove this participant?</p>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentQuestion;
